import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined, LoadingOutlined, UserOutlined, ClockCircleOutlined, CheckCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { Avatar, Comment, Form, Input, Modal, Spin, Tag, Tooltip, message } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { authFetch } from "../../../../../common/request/authFetch";
import { STATUS } from "../../../../../common/constants/statusFAQAndReviews";
import { ButtonLZ } from "../../../design/Buttons/ButtonLZ";
import ReviewComment from "../../../../pages/menuReviews/3_1_Reviews/Reviews/ReviewComment";
import { EmojiPickerCustom } from "../../../design/EmojiPicker/EmojiPickerCustom";
import { useIsAuthorized } from "../../../../pages/common/roles/Roles";
import { useAuth } from "../../../../../store/AuthContext/AuthContext";

export const ReviewAnswer = ({ getResponseIa, submitReply, replyForm, isLoadingIa, review, onFinish }: any) => {

    const { t } = useTranslation();
    const isAuthorized = useIsAuthorized();
    const [status, setStatus] = useState('');
    const [showPicker, setShowPicker] = useState(false);

    const [cursorIndex, setCursorIndex] = useState(0);
    const { projectGroup } = useAuth();

    // Función para renderizar el estado de la respuesta de Google
    const renderStateTag = (state: string) => {
        const iconStyle = { fontSize: '16px' };

        switch (state) {
            case 'APPROVED':
                return (
                    <Tooltip title="Aprobada por Google">
                        <CheckCircleOutlined style={{ ...iconStyle, color: '#52c41a' }} />
                    </Tooltip>
                );
            case 'PENDING':
                return (
                    <Tooltip title="Pendiente de moderación por Google">
                        <ClockCircleOutlined style={{ ...iconStyle, color: '#1890ff' }} />
                    </Tooltip>
                );                
            case 'REJECTED':
                return (
                    <Tooltip title="Rechazada por Google">
                        <CloseCircleOutlined style={{ ...iconStyle, color: '#ff4d4f' }} />
                    </Tooltip>
                );                
            case 'REVIEW_REPLY_STATE_UNSPECIFIED':
            default:
                return (
                    <></>
                );                
        }
    };

    const handleFocus = (event:any) => {
        setShowPicker(false);        
    }

    const handleBlur = (event:any) => {
        setCursorIndex(event.target.selectionStart);
    };

    const handleEmojiClick = (emoji:any) => {    
        const textArea = replyForm.getFieldValue('comment');
        const textAreaWithEmoji = 
                (textArea || "").slice(0, cursorIndex) +
                emoji.native +
                (textArea || "").slice(cursorIndex);
        replyForm.setFieldsValue({ comment: textAreaWithEmoji });
    };    

    const deleteReply = async (): Promise<void> => {
        const data = {
            reviewId: review.name
        };
        await authFetch(
            `${process.env.REACT_APP_API}/projects/` + projectGroup.project + '/reviews/reply',
            { method: 'DELETE', data }
        )
            .then((res) => {
                if (res) {
                    message.success(t('view.forms.modal.reviews.delete.success', { name: review.reviewerDisplayName }), 3);
                    onFinish();
                } else {
                    message.error(t('view.forms.modal.reviews.delete.error', { name: review.reviewerDisplayName }), 3);
                }
            })
    }    
    
    return (
        <>
            <Comment
                actions={
                    isAuthorized(['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_CLIENT', 'ROLE_MODULE_REVIEWS']) && status !== STATUS.EDITING ? ([
                        <a className='review-btn-grey'
                            onClick={() => setStatus('Editing')}>
                            <EditOutlined style={{ marginRight: '2px' }} />
                            {t('dictionary.edit')}
                        </a>,
                        <a className='review-btn-grey'
                            onClick={() => {
                                Modal.confirm({
                                    title: t('reviews.page.reply.tabs.reviews.delete.confirm'),
                                    okText: t('dictionary.confirm'),
                                    cancelText: t('dictionary.cancel'),
                                    onOk: () => deleteReply()
                                })
                            }}
                        >
                            <DeleteOutlined style={{ marginRight: '2px' }} />
                            {t('dictionary.delete')}
                        </a>
                    ]) : undefined
                }
                author={
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div style={{ color: 'black', fontSize: '14px', display: 'flex', alignItems: 'center' }}>
                            <Avatar style={{ backgroundColor: '#87d068', marginRight: '10px' }} icon={<UserOutlined />} />
                            {t('dictionary.owner')}
                        </div>
                        
                        {!!review.reviewReplyComment && (
                            <div style={{ marginLeft: '10px' }}>
                                {}
                            </div>
                        )}
                    </div>
                }
                datetime={
                    status === STATUS.EDITING &&
                    <div style={{ display:'flex', justifyContent:'space-between' }}>
                        <ButtonLZ
                            onClick={() => {
                                getResponseIa();
                            }}
                            //style={{ marginRight:'30px' }}
                            size='small' color='dark-white'>{isLoadingIa ? <Spin indicator={<LoadingOutlined spin />} /> : t('reviews.page.reply.review.btn.ia')}</ButtonLZ>
                    </div>
                }
                content={                    
                    status === STATUS.EDITING ? (
                        <Form layout='vertical'
                            form={replyForm}
                            onFinish={submitReply}
                            initialValues={{comment : review.reviewReplyComment?.originalText ? review.reviewReplyComment?.originalText : review.reviewReplyComment?.text}}
                        >                                                        
                            <Form.Item name='comment'>
                                <Input.TextArea
                                    className='comment-answer'                            
                                    style={{ width: '92%'}}
                                    rows={6}
                                    onFocus={handleFocus}
                                    onBlur={handleBlur}
                                />
                            </Form.Item>
                            <div>
                                <a className='review-btn'
                                    onClick={() => { replyForm.resetFields(); setStatus(''); }}
                                >
                                    <CloseOutlined /> {t('dictionary.cancel')}
                                </a>
                                <a className='review-btn'
                                    onClick={() => { replyForm.submit(); setStatus(''); }}
                                >
                                    <CheckOutlined /> {t('dictionary.accept')}
                                </a>
                            </div>
                            <EmojiPickerCustom  handleEmojiClick={handleEmojiClick} showPicker={showPicker} setShowPicker={setShowPicker}/>
                        </Form>
                    ) : (
                        !!review.reviewReplyComment && (
                            <>
                                <ReviewComment comment={review.reviewReplyComment} scope={review.replyScope}  isObsolete={!!review.obsoleteReply} reviewReplyUpdateTime={review.reviewReplyUpdateTime} isReply={true} googleState={renderStateTag(review.reviewReplyState)}/> 
                            </>
                        )
                    )
                }
            />
        </>
    )
}